import { GDFPalletCode } from '../gdf/type';
import { Palette } from './palettes';

export const airports: Palette[] = [
    {
        name: 'METAR/TAF - Flight Category',
        id: GDFPalletCode.metar,
        type: 'categorical',
        entries: [
            {
                label: 'Not available',
                color: '#5A5A5A'
            },
            {
                label: 'VFR',
                color: '#00DC00'
            },
            {
                label: 'MVFR',
                color: '#FFFF00'
            },
            {
                label: 'IFR',
                color: '#FA7D00'
            },
            {
                label: 'LIFR',
                color: '#FF0000'
            },
            {
                label: 'BCAT1',
                color: '#FF00FF'
            }
        ]
    },
    {
        name: 'METAR/TAF - Ceiling',
        id: GDFPalletCode.metar_ceiling,
        type: 'categorical',
        entries: [
            {
                label: 'Ceiling >= 10,000 ft',
                color: '#87CEFF'
            },
            {
                label: 'Ceiling < 10,000 ft',
                color: '#33DCFF'
            },
            {
                label: 'Ceiling < 5,000 ft',
                color: '#0083FF'
            },
            {
                label: 'Ceiling < 3,000 ft',
                color: '#00FF00'
            },
            {
                label: 'Ceiling < 2,000 ft',
                color: '#FFFF00'
            },
            {
                label: 'Ceiling < 1,000 ft',
                color: '#FF8000'
            },
            {
                label: 'Ceiling < 500 ft',
                color: '#FF80A5'
            },
            {
                label: 'Ceiling < 200 ft',
                color: '#FF00FF'
            },
            {
                label: 'Not available',
                color: '#5A5A5A'
            }
        ]
    },
    {
        name: 'METAR/TAF - Visibility',
        id: GDFPalletCode.metar_visibility,
        type: 'categorical',
        entries: [
            {
                label: 'Visibility >= 10 mi',
                color: '#87CEFF'
            },
            {
                label: 'Visibility < 10 mi',
                color: '#0083FF'
            },
            {
                label: 'Visibility < 5 mi',
                color: '#67FF67'
            },
            {
                label: 'Visibility < 3 mi',
                color: '#FFFF67'
            },
            {
                label: 'Visibility < 2 mi',
                color: '#FFA500'
            },
            {
                label: 'Visibility < 1 mi',
                color: '#FF80A5'
            },
            {
                label: 'Visibility < 1/2 mi',
                color: '#FF0000'
            },
            {
                label: 'Visibility < 1/4 mi',
                color: '#FF00FF'
            },
            {
                label: 'Not available',
                color: '#5A5A5A'
            }
        ]
    },
    {
        name: 'Airport Delays',
        id: GDFPalletCode.delay,
        type: 'categorical',
        entries: [
            {
                label: 'No delays',
                color: '#00ff00'
            },
            {
                label: 'Arr/dep delays 16-45 min',
                color: '#ffff00'
            },
            {
                label: 'Arr/dep delays > 45 min',
                color: '#ff0000'
            },
            {
                label: 'Ground delay/stop',
                color: '#ff8000'
            },
            {
                label: 'Airport closed',
                color: '#3030F0'
            }
        ]
    },
    {
        name: 'RVR (Runway visual range)',
        id: GDFPalletCode.rvr,
        type: 'categorical',
        entries: [
            { label: 'All runways >= 6,000 ft', color: 'rgb(0,220,0)' },
            { label: 'One or more runways >= 2,400 and < 6,000 ft', color: 'rgb(0,131,255)' },
            { label: 'One or more runways >= 1,200 and < 2,400 ft', color: 'rgb(255,255,0)' },
            { label: 'One or more runways >= 600 and < 1, 200 ft', color: 'rgb(250,125,0)' },
            { label: 'One or more runways >= 300 and < 6000 ft', color: 'rgb(255,0,0)' },
            { label: 'One or more runways < 300> ft', color: 'rgb(255,0,255)' }
        ]
    },
    {
        name: 'Diversion',
        id: GDFPalletCode.diversion,
        type: 'categorical',
        entries: [
            {
                label: '0-1 diversions',
                color: '#00dc00'
            },
            {
                label: '2-3 diversions',
                color: '#0000dc'
            },
            {
                label: '4-5 diversions',
                color: '#ffff00'
            },
            {
                label: '6-9 diversions',
                color: '#fa7d00'
            },
            {
                label: '10+ diversions',
                color: '#ff0000'
            }
        ]
    }
];
